import Vue from 'vue';
import store from '@/store';

// Helper function to clean up HTML by removing Vue scoped attributes and unnecessary whitespace
function cleanHTML(html) {
  // Remove Vue's scoped CSS attributes
  html = html.replace(/ data-v-[a-z0-9]+=""/g, '').trim();

  // Remove multiple spaces
  html = html.replace(/\s\s+/g, ' ');

  // Remove empty <p> tags
  html = html.replace(/<p>\s*<\/p>/g, '');

  // Remove excessive line breaks and extra spaces between tags
  html = html.replace(/>\s+</g, '><');

  return html;
}

// Main function to render a Vue component to a string
export function renderComponentToString(component, propsData = {}) {
  // Create a Vue constructor for the component
  const Constructor = Vue.extend(component);
  // Mount the component instance with props and store
  const vm = new Constructor({
    propsData,
    store,
  }).$mount();

  // Get the inner HTML of the component's root element
  let htmlContent = vm.$el.innerHTML;

  // Clean the HTML content to remove unnecessary spaces and line breaks
  htmlContent = cleanHTML(htmlContent);

  return htmlContent;
}
